const selectSelectedMultipleChoiceExerciseOption = (state, exerciseId) => {
  return state.multipleChoiceExerciseUi[exerciseId];
};
export default selectSelectedMultipleChoiceExerciseOption;